module.exports = __webpack_public_path__ + "static/media/track.c6458901.svg";